import { render, staticRenderFns } from "./boxStatement.vue?vue&type=template&id=68a22bc6&scoped=true"
import script from "./boxStatement.vue?vue&type=script&lang=js"
export * from "./boxStatement.vue?vue&type=script&lang=js"
import style0 from "./boxStatement.vue?vue&type=style&index=0&id=68a22bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a22bc6",
  null
  
)

export default component.exports